
const mLogSvc = new WeakMap();

class AppOverlayService {
    constructor($log) {
        mLogSvc.set(this, $log);
        this._showOverlay = false;
        this._overlayMessage = "Loading";
        this._overlayType = "primary";
    }

    get showOverlay() {
        return this._showOverlay;
    }

    set showOverlay(updatedValue) {
        const updatedOverlayValue = (updatedValue === true);
        this._showOverlay = updatedOverlayValue;
        mLogSvc.get(this).debug(`App Overlay Service: Set Show Overlay To ${updatedOverlayValue}.`);
    }

    get overlayMessage() {
        return this._overlayMessage;
    }

    set overlayMessage(updatedMessage) {
        this._overlayMessage = updatedMessage;
        mLogSvc.get(this).debug(`App Overlay Service: Set Overlay Message To '${updatedMessage}'`);
    }

    get overlayType() {
        return this._overlayType;
    }

    set overlayType(updatedTypeName) {
        this._overlayType = updatedTypeName;
        mLogSvc.get(this).debug(`App Overlay Service: Set Overlay Type To ${updatedTypeName}`);
    }
}

AppOverlayService.$inject = [
    "$log"
];
AppOverlayService.dependencies = [];

export default AppOverlayService;



//////////////////
// WEBPACK FOOTER
// ./src/directives/app-overlay/AppOverlayService.js
// module id = EWgv
// module chunks = 1